/** Default when country is unknown — matches previous Pakistan-oriented UI. */
export const DEFAULT_CURRENCY_CODE = "PKR";
export const DEFAULT_CURRENCY_LABEL = "Rs";

/**
 * Map company country to currency code (API) + display label (UI).
 * Saudi Arabia → SAR / SAR
 * Pakistan → PKR / Rs
 */
export function resolveCurrencyFromCountry(country) {
  const normalized = String(country || "")
    .trim()
    .toLowerCase();

  if (normalized.includes("saudi")) {
    return { code: "SAR", label: "SAR" };
  }
  if (normalized.includes("pakistan")) {
    return { code: "PKR", label: "Rs" };
  }

  return { code: DEFAULT_CURRENCY_CODE, label: DEFAULT_CURRENCY_LABEL };
}

/** ISO-style code for API payloads (PKR / SAR). */
export function getCurrencyCodeFromState(state) {
  return (
    state?.companyInfoState?.currencyCode ||
    state?.globalState?.currencyCode ||
    DEFAULT_CURRENCY_CODE
  );
}

/** UI label (Rs for Pakistan, SAR for Saudi Arabia). */
export function getCurrencyLabelFromState(state) {
  const explicit =
    state?.companyInfoState?.currencyLabel ||
    state?.globalState?.currencyLabel;
  if (explicit) return explicit;

  const code = getCurrencyCodeFromState(state);
  return code === "SAR" ? "SAR" : DEFAULT_CURRENCY_LABEL;
}
